import React from 'react';
import { DateTimeInput } from 'src/components/DateTimeInput/DateTimeInput';

interface AuditHeaderPropsType {
    title: string;
    from: string | undefined;
    to: string | undefined;
    onChangeFrom: (date: string | null) => void;
    onChangeTo: (date: string | null) => void;
    dataTest?: string;
}

export const AuditHeader = ({
    title,
    from,
    to,
    onChangeFrom,
    onChangeTo,
    dataTest,
}: AuditHeaderPropsType): React.ReactElement => (
    <div className='audit-details'>
        <div className='row'>
            <div className='col-6'>
                <h3 data-test={dataTest}>{title}</h3>
            </div>
            <div className='col-2'>
                <div className='form'>
                    <div className='element'>
                        <DateTimeInput
                            value={from ?? ''}
                            onChange={onChangeFrom}
                        />
                    </div>
                </div>
            </div>
            <div className='col-2'>
                <div className='form'>
                    <div className='element'>
                        <DateTimeInput
                            value={to ?? ''}
                            onChange={onChangeTo}
                        />
                    </div>
                </div>
            </div>
            <div className='col-2'></div>
        </div>
    </div>
);
